<div class="sz-lap gj-lap">
  <div class="ures" *ngIf="!u"><ion-icon name="business-outline"></ion-icon>Válassz céget a fejlécben.</div>
  <ng-container *ngIf="u">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" *ngIf="ir" (click)="uj()"><ion-icon name="add"></ion-icon>Új sofőr</button>
      <input type="search" [(ngModel)]="kereso" placeholder="Név, adóazonosító, csoport…" style="min-width:220px">
      <label><input type="checkbox" [(ngModel)]="inaktiv"> inaktívak is</label>
      <span class="spacer"></span>
      <a class="ov-link" routerLink="/gepjarmu/beallitasok">← Beállítások</a>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs sz-racs">
        <thead><tr><th>Név</th><th>Adóazonosító</th><th>Bér dolgozó</th><th>Csoport</th><th>Alap jármű</th><th class="num">Utak</th><th class="num" title="A mai naptól">Szabadnap</th><th>Állapot</th></tr></thead>
        <tbody>
          <tr *ngFor="let s of lathato" class="kattinthato" [class.halvany-sor]="!s.aktiv" (click)="nyit(s)">
            <td><b>{{ s.nev }}</b></td>
            <td>{{ s.adoazonosito }}</td>
            <td>{{ s.ber_nev || '' }}<span class="gj-jel" *ngIf="s.ber_inaktiv"> a Bérben inaktív</span></td>
            <td>{{ s.csoport }}</td>
            <td>{{ s.alap_jarmuvek }}</td>
            <td class="num">{{ s.ut_db || '' }}</td>
            <td class="num">{{ jovoSzabadnap(s) || '' }}</td>
            <td><span class="sz-allapot" [attr.data-a]="s.aktiv ? 'kesz' : 'nincs'">{{ s.aktiv ? 'aktív' : 'inaktív' }}</span></td>
          </tr>
        </tbody>
      </table>
      <div class="sz-ures" *ngIf="!lathato.length && !betolt">Nincs sofőr.<ng-container *ngIf="ir"> Az „Új sofőr” gombbal vehetsz fel – a Bér dolgozóiból is.</ng-container></div>
    </div>
  </ng-container>
</div>

<!-- ═══ SOFŐR ═══ -->
<ion-modal [isOpen]="!!szerk" (didDismiss)="bezar()" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? szerk.nev : 'Új sofőr' }}</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa gj-ablak" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
        <div class="sa-doboz">
          <label class="kv-mezo gj-teljes"><span>Bér dolgozó</span>
            <select [ngModel]="szerk.ber_alkalmazott_id" (ngModelChange)="dolgozoValt($event)" [disabled]="!ir"><option [ngValue]="null">– nincs kötve (külsős) –</option>
              <option *ngFor="let d of dolgozoLista" [ngValue]="d.id">{{ d.nev }}{{ d.torzsszam ? ' (' + d.torzsszam + ')' : '' }}{{ d.inaktiv ? ' – inaktív' : '' }}</option></select></label>
          <p class="gj-sugo" *ngIf="!dolgozok.length">A cégnek nincs dolgozója a Bérben (vagy a Bér nincs a céghez kötve). Kötés nélkül a sofőr külsősként rögzíthető;
            a kiküldetési költségtérítés Bérbe adásához kell a kötés.</p>
          <label class="kv-mezo"><span>Név *</span><input type="text" [(ngModel)]="szerk.nev" [disabled]="!ir" maxlength="120"></label>
          <label class="kv-mezo"><span>Adóazonosító jel</span><input type="text" [(ngModel)]="szerk.adoazonosito" [disabled]="!ir" maxlength="10" inputmode="numeric" placeholder="8xxxxxxxxx"></label>
          <label class="kv-mezo gj-teljes"><span>Lakcím</span><input type="text" [(ngModel)]="szerk.lakcim" [disabled]="!ir" maxlength="190"></label>
          <label class="kv-mezo"><span>Csoport</span><input type="text" [(ngModel)]="szerk.csoport" [disabled]="!ir" list="gjSoforCsoportok" maxlength="60"></label>
          <datalist id="gjSoforCsoportok"><option *ngFor="let c of csoportok" [value]="c"></option></datalist>
          <div class="sa-jelolok"><label><input type="checkbox" [(ngModel)]="szerk.aktiv" [disabled]="!ir"> aktív</label></div>
          <label class="kv-mezo gj-teljes"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes" [disabled]="!ir" maxlength="255"></label>
        </div>
        <div class="sa-doboz">
          <div class="gj-szakasz gj-teljes">Szabadnapok <small class="halvany">({{ szerk.szabadnapok.length }} nap – a havi tervező ezekre nem tervez utat)</small></div>
          <ng-container *ngIf="ir">
            <div class="kv-mezo"><span>Egy nap</span><span class="kv-egyutt"><input type="date" [(ngModel)]="ujNap" [disabled]="zarolt" (keydown.enter)="napHozzaad()">
              <button type="button" class="ov-gomb" [disabled]="!ujNap || zarolt" (click)="napHozzaad()"><ion-icon name="add"></ion-icon></button></span></div>
            <div class="kv-mezo"><span>Időszak</span><span class="kv-egyutt"><input type="date" [(ngModel)]="tartomany.tol" [disabled]="zarolt"><span>–</span><input type="date" [(ngModel)]="tartomany.ig" [disabled]="zarolt">
              <button type="button" class="ov-gomb" [disabled]="!tartomany.tol || !tartomany.ig || zarolt" (click)="tartomanyHozzaad()" title="A hétköznapok kerülnek be"><ion-icon name="add"></ion-icon></button></span></div>
          </ng-container>
          <div class="gj-chipek">
            <span *ngFor="let n of szerk.szabadnapok">{{ n }}<button type="button" *ngIf="ir && !zarolt" (click)="napTorol(n)" title="Törlés">×</button></span>
            <span class="halvany" *ngIf="!szerk.szabadnapok.length" style="border:0;background:transparent">Nincs rögzített szabadnap.</span>
          </div>
          <div class="gj-teljes" *ngIf="ir && regiNapok"><button type="button" class="ov-link" (click)="regiTorol()">a(z) {{ regiNapok }} elmúlt nap törlése a listából</button></div>
        </div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" *ngIf="ir" [disabled]="zarolt || ment" (click)="mentes()"><ion-icon name="checkmark"></ion-icon>Mentés</button>
          <button type="button" class="kv-torol" *ngIf="ir && szerk.id" [disabled]="zarolt" (click)="torol()" title="Sofőr törlése"><ion-icon name="trash-outline"></ion-icon></button>
          <span class="spacer"></span><button type="button" class="ov-gomb" (click)="bezar()">Bezár</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
